import { render, staticRenderFns } from "./JgpArea.vue?vue&type=template&id=793d4fba&"
import script from "./JgpArea.vue?vue&type=script&lang=js&"
export * from "./JgpArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports